<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-card flat>
          <v-card-title><span class="headline my-4">Welcome to Arup's <strong>Carbon Insights Platform</strong></span></v-card-title>
          <v-card-text>
            <p>
              This platform has two primary purposes - to aid and educate designers at the early stages of design on the potential impact of projects; 
              and to better understand and visualise the environmental impact of construction projects by utilising the data available to us.
              Within this platform you'll find a number of initiatives dedicated to this cause. 
            </p>
            <p>
              These initiatives include a library of "typologies" providing bottom-up guidance, a pre-design calculation tool looking at 
              potential impact, and an insights page which gathers and sorts the output of completed embodied carbon calculations from Arup
              projects.
            </p>
          </v-card-text>
          <v-img 
            :src = diagram 
            height="400px" 
            contain 
          ></v-img>
          <v-card-text>
            <p>
              Equipped with this knowledge we can work at pushing projects towards a more sustainable future. 
              We hope you can find good uses for it.
            </p>
            <p>
              If there's anything you think we could be doing more of feel free to get in touch via the contributors page.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-flex
        v-for="card in cards"
        :key = "card.title"
        sm12 md6 xl6
      >
        <v-col>
          <v-card
            :height = card.height
            class = 'align-end'
            :to = card.route
            hover
          >
            <v-img
              :src = card.src
              height = '200px'
              class="align-end"
            >
            </v-img>
            <v-card-title> {{ card.title }} </v-card-title>
            <v-card-text> {{ card.text }} </v-card-text>
          </v-card>
        </v-col>
      </v-flex>
    </v-row>
    
     
  </v-container>


</template>

<script>


    
export default {
  name: 'Home',


  components: {
    
  },
  data: () => ({

      diagram: require('@/assets/home/carbon-chart-v2.png'),
      input:'First',
  inputs: [],
      cards: [
        {
          title: 'Buildings Typology Library',
          text: 'Guidance values for common systems and typologies for commercial buildings',
          src: require('@/assets/home/typ.png'),
          route: '/typ-library-buildings',
          height: '100%'
        },
        {
          title: 'Infrastructure Typology Library',
          text: 'Guidance values for common systems and typologies for infrastructure assets',
          src: require('@/assets/home/typ-infra.png'),
          route: '/typ-library-infrastructure',
          height: '100%'
        },
        {
          title: 'Buildings Pre-Design Calculator',
          text: 'Creating bespoke targets for projects prior to design',
          src: require('@/assets/home/calculator.png'),
          route: '/calculator',
          height: '100%'
        },
        {
          title: 'Project Insights',
          text: 'A look at the embodied carbon of completed calculations within Arup',
          src: require('@/assets/home/insights-chart.png'),
          route: '/insights',
          height: '100%'
        },
        // {
        //   title: 'Project Case Studies',
        //   text: 'Good news stories on projects who have achieved sustainable outcomes',
        //   src: require('@/assets/home/casestudy.png'),
        //   route: '/case-studies',
        //   height: '100%'
        // }
      ]
  }),

}
</script>
